import { getConfig } from "@edx/frontend-platform";
import React, { useMemo, useState } from "react";

const MaintenanceBanner = ({ onClose, maintenanceMsg }) => (
  <div
    role="alert"
    style={{
      background: "#FDECEC",
      border: "1px solid #F5C2C2",
      color: "#B00020",
      fontSize: 14,
      fontWeight: 500,
      padding: "10px 20px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 16,
      textAlign: "center",
      height: "unset",
      flexDirection: "row",
      position: "relative",
    }}
  >
    <span>{maintenanceMsg}</span>
    <button
      type="button"
      onClick={onClose}
      aria-label="Dismiss maintenance notice"
      style={{
        background: "none",
        border: "none",
        color: "#B00020",
        fontSize: 18,
        lineHeight: 1,
        cursor: "pointer",
        padding: 0,
        fontWeight: 700,
        position: "absolute",
        right: "15px",
      }}
    >
      ×
    </button>
  </div>
);

const parseStrictDate = (dateStr) => {
  if (!dateStr || typeof dateStr !== "string") return null;

  const pattern = /^(\d{4})-(\d{2})-(\d{2})(?: (\d{2}):(\d{2}))?$/;
  const match = dateStr.trim().match(pattern);
  if (!match) return null;

  const [, year, month, day, hours = "00", minutes = "00"] = match;
  const y = Number(year);
  const mo = Number(month);
  const d = Number(day);
  const h = Number(hours);
  const mi = Number(minutes);

  if (mo < 1 || mo > 12 || d < 1 || d > 31 || h > 23 || mi > 59) return null;

  const date = new Date(y, mo - 1, d, h, mi);

  if (
    date.getFullYear() !== y ||
    date.getMonth() !== mo - 1 ||
    date.getDate() !== d
  ) {
    return null;
  }

  return date;
};
const shouldShowMaintenanceBanner = (startDateStr, endDateStr) => {
  const start = parseStrictDate(startDateStr);
  const end = parseStrictDate(endDateStr);

  if (!start || !end) return false;

  const now = new Date();

  if (now < start) return false;
  if (now > end) return false;

  return true;
};

export default function BannerComponent({ onClose }) {
  const [showBanner, setShowBanner] = useState(true);
  const maintenanceConfig = getConfig().MAINTENANCE_CONFIG || {};
  const maintenanceMsg = maintenanceConfig?.message;
  const maintenanceStart = maintenanceConfig?.start_date;
  const maintenanceEnd = maintenanceConfig?.end_date;
  const maintenanceEP = maintenanceConfig?.enabled_pages;

  const withinWindow = useMemo(
    () => shouldShowMaintenanceBanner(maintenanceStart, maintenanceEnd),
    [maintenanceEnd],
  );

  return (
    <>
      {maintenanceEP?.includes("authn") &&
        withinWindow &&
        maintenanceMsg &&
        maintenanceMsg.length > 0 &&
        showBanner && (
          <MaintenanceBanner
            maintenanceMsg={maintenanceMsg}
            onClose={() => setShowBanner(false)}
          />
        )}
    </>
  );
}
